import { render, staticRenderFns } from "./BodyType.vue?vue&type=template&id=31c231c3&scoped=true"
import script from "./BodyType.vue?vue&type=script&lang=js"
export * from "./BodyType.vue?vue&type=script&lang=js"
import style0 from "./BodyType.vue?vue&type=style&index=0&id=31c231c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c231c3",
  null
  
)

export default component.exports